<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <div class="list-user list-files container list-employee">
      <div>
        <div class="list-user--table">
          <div class="header-table header-table-custom">
            <b-row>
              <b-col md="4">
                <h2 class="heading2">
                  従業員数 :
                  <span>{{totalItems}}</span>
                </h2>
              </b-col>
              <b-col md="8">
                <div class="filter-wrapper">
                  <b-form inline class="float-md-right">
                    <label class="mr-sm-2" for="sort-data">並び替え:</label>
                    <b-form-select
                        id="sort-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortBy"
                        :options="[
                            { text: '名前', value: 'name' },
                            { text: '日にち', value: 'created_at' },
                            { text: 'Eメール', value: 'email' },
                            { text: '役割', value: 'role_id' }
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="sort-order-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortOrder"
                        :options="[
                            { text: 'Desc', value: 'desc' },
                            { text: 'Asc', value: 'asc' }
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="per-page"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.perPage"
                        :options="[
                            { text: '10', value: 10 },
                            { text: '50', value: 50 },
                            { text: '100', value: 75 },
                        ]"
                    ></b-form-select>
                    <b-form-input
                        id="sort-order-data"
                        class="input-form"
                        type="search"
                        placeholder="Search"
                        v-model="paginations.searchQuery"
                        @input="onSearch(paginations.searchQuery)"
                    ></b-form-input>
                </b-form>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="body-table dashboard" style="min-height: 70vh;">
            <table class="table table-csUser table-mb-pd">
              <thead>
              <tr>
                <th scope="col" class="w-40 mb-w-67">名前</th>
                <th scope="col" class="hidden-mb w-10">所属</th>
                <th scope="col" class="hidden-mb w-10">ロール</th>
                <th scope="col" class="w-15 mb-w-23">電話番号</th>
                <th scope="col" class="hidden-mb w-15">メールアドレス</th>
                <th scope="col" class="w-10"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="employee in employees" v-bind:key="employee.id" @dblclick="detailEmployee(employee.id)" title="ダブルタップして開きます">
                <th scope="row" class="table-name w-30 mb-w-75">
                  <div class="table-name--box files">
                    <div class="favorite">
                      <img :src="employee.avatar" alt="" class="avt-folder" />
                    </div>
                    <div class="admin-name admin-name-break flex-wrap">
                      <div class="name-bold w-100">{{truncate(employee.name,8,'...')}}</div>
                      <div class="id">コード: {{truncate(employee.employee_code,7,'...')}}</div>
                    </div>
                  </div>
                </th>
                <td class="table-department hidden-mb w-20">
                  {{truncate(employee.position,8,'...')}}
                </td>
                <td class="table-role hidden-mb w-10">{{convertName(role(employee.role_id))}}</td>
                <td class="table-phone w-15">
                  {{truncate(employee.phone,11,'...')}}
                </td>
                <td class="table-phone hidden-mb w-10">{{truncate(employee.email,25,'...')}}</td>
                <td class="table-action text-right wider-click w-10">
                  <b-dropdown class="dropdownAction dropdown-files dropdown-vendor" variant="link"  toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="icon-i-dot"></i>
                    </template>
                    <b-dropdown-item @click.prevent="detailEmployee(employee.id)">
                      <i class="icon-i-eyes"></i>
                      <span>開く</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showModalEdit(employee.id)">
                      <i class="icon-i-edit"></i>
                      <span>編集</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showModalDelete(employee.id)">
                      <i class="icon-i-trash"></i>
                      <span>削除</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
            <nav aria-label="Page navigation" v-if="showPage">
              <ul class="pagination">
                <li class="page-item" :class="hasPrev"><a class="page-link prev" @click.prevent="changePage(page_index-1)"><i class="icon-i-prev"></i></a></li>
                <li class="page-item" v-for="(page,index) in pageNumber" v-bind:key="index"><a class="page-link" v-bind:class="{'active': page.value === page_index}" @click.prevent="changePage(page.value)">{{page.text}}</a></li>
                <li class="page-item" :class="hasNext"><a class="page-link next" @click.prevent="changePage(page_index+1)"><i class="icon-i-next"></i></a></li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="buttonFixed">
          <button class="btn btn-circle btnpulse btn-primary btn-addUser" @click="showModalAdd">
            <!--<img src="@img/admin/add-employee.svg" class="admin-addVendorImg" /> -->
            <svg id="Group_9879" data-name="Group 9879" xmlns="http://www.w3.org/2000/svg" width="28.184" height="28.184" viewBox="0 0 28.184 28.184">
              <g id="Group_9876" data-name="Group 9876">
                <g id="Group_9875" data-name="Group 9875">
                  <path id="Path_8698" data-name="Path 8698" d="M20.234,14.142a14.324,14.324,0,0,0-1.657-.665,7.486,7.486,0,1,0-8.964,0A14.32,14.32,0,0,0,.072,24.151a3.345,3.345,0,0,0,3.27,4.034H16.9a1.1,1.1,0,1,0,0-2.2H3.341a1.119,1.119,0,0,1-.881-.419,1.15,1.15,0,0,1-.233-.964A12.164,12.164,0,0,1,13.8,14.967q.145.006.292.006t.295-.006a11.992,11.992,0,0,1,4.9,1.164,1.1,1.1,0,0,0,.945-1.989Zm-5.873-1.378-.269,0-.266,0a5.285,5.285,0,1,1,.535,0Z" transform="translate(0)" fill="#fff"/>
                </g>
              </g>
              <g id="Group_9878" data-name="Group 9878" transform="translate(17.725 17.725)">
                <g id="Group_9877" data-name="Group 9877">
                  <path id="Path_8699" data-name="Path 8699" d="M331.358,326.128H328.33V323.1a1.1,1.1,0,0,0-2.2,0v3.028H323.1a1.1,1.1,0,0,0,0,2.2h3.028v3.028a1.1,1.1,0,0,0,2.2,0V328.33h3.028a1.1,1.1,0,0,0,0-2.2Z" transform="translate(-322 -322)" fill="#fff"/>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <modalAddEmployee />
    <modalEditEmployee />
    <modalDeleteEmployee :idDelete="idDelete"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Tabs from '../../../../components/Admin/Company/Tabs'
import { BModal } from 'bootstrap-vue'
import modalAddEmployee from '@/views/Admin/Company/Employee/Add'
import modalEditEmployee from '@/views/Admin/Company/Employee/Edit'
import modalDeleteEmployee from '@/views/Admin/Company/Employee/Delete'
export default {
  name: 'List_Employee',
  data () {
    return {
      idDelete: '',
      page_index: 1,
      tabIndex: 4,
      paginations: {
        page_index: this.page_index,
        sortBy: 'created_at',
        sortOrder: 'desc',
        perPage: 10,
        searchQuery: '',
        typingTimer: null,
        isTyping: false
      }
    }
  },
  components: {
    BModal,
    modalAddEmployee,
    modalEditEmployee,
    modalDeleteEmployee,
    Tabs
  },
  methods: {
    convertName (value) {
      if (value === 'employee') {
        return '社員'
      }
      if (value === 'manager') {
        return '管理者'
      }
    },
    detailEmployee (id) {
      this.$router.push(`/admin/companies/${this.$route.params.id}/employees/${id}`)
    },
    role (value) {
      return value === 2 ? 'manager' : 'employee'
    },
    changePage (pageIndex) {
      this.page_index = pageIndex
      this.$store.dispatch('adminEmployee/getEmployee', {page_index: this.page_index, company_id: this.$route.params.id})
    },
    showModalAdd () {
      this.$root.$emit('bv::show::modal', 'modalAddEmployee', '#modalAddEmployee')
    },
    showModalEdit (id) {
      this.$store.dispatch('adminEmployee/detailEmployee', {id: id})
      this.$root.$emit('bv::show::modal', 'modalEditEmployee', '#modalEditEmployee')
    },
    showModalDelete (id) {
      this.idDelete = id
      this.$root.$emit('bv::show::modal', 'modalDeleteEmployee', '#modalDeleteEmployee')
    },
    onSearch (keyword) {
      let vm = this
      vm.paginations.page_index = 1
      clearTimeout(vm.paginations.typingTimer)
      if (keyword === '') {
        vm.paginations.isTyping = false
        this.$store.dispatch('adminEmployee/getEmployee', {
          page_index: this.page_index,
          company_id: this.$route.params.id,
          perPage: this.paginations.perPage,
          sortBy: this.paginations.sortBy,
          sortOrder: this.paginations.sortOrder,
          searchQuery: this.paginations.searchQuery
        })
        return
      }

      vm.paginations.typingTimer = setTimeout(() => {
        vm.$store.dispatch('adminEmployee/getEmployee', {
          page_index: this.page_index,
          company_id: this.$route.params.id,
          perPage: this.paginations.perPage,
          sortBy: this.paginations.sortBy,
          sortOrder: this.paginations.sortOrder,
          searchQuery: this.paginations.searchQuery
        })
      }, 500)
    },
    filterDisplay () {
      let vm = this
      vm.paginations.isTyping = true
      vm.$store.dispatch('adminEmployee/getEmployee', {
        page_index: this.page_index,
        company_id: this.$route.params.id,
        perPage: this.paginations.perPage,
        sortBy: this.paginations.sortBy,
        sortOrder: this.paginations.sortOrder,
        searchQuery: this.paginations.searchQuery
      })
    }
  },
  mounted () {
    this.$store.dispatch('adminEmployee/getEmployee', {page_index: this.page_index, company_id: this.$route.params.id})
  },
  computed: {
    ...mapState({
      employees: state => state.adminEmployee.employees,
      totalItems: state => state.adminEmployee.totalItems,
      totalPages: state => state.adminEmployee.totalPages
    }),
    pageNumber () {
      const arr = []
      if (this.totalPages === 1) {
        return arr
      }
      const start = 1
      const end = this.totalPages
      const showPageCount = 6
      if (end <= showPageCount + 3) {
        for (let i = start; i <= end; i++) {
          arr.push({text: i, value: i})
        }
        return arr
      }
      arr.push({ text: start, value: start, show: '' })
      if (this.page_index >= 5) {
        arr.push({
          text: '...',
          value: '',
          show: 1
        })
      }
      let listStart = this.page_index - Math.floor(showPageCount / 2) + 1
      if (listStart <= 1) listStart = 2
      let listEnd = listStart + showPageCount - 1
      if (listEnd >= end) listEnd = end - 1
      listStart = listEnd - showPageCount + 1
      for (let i = listStart; i <= listEnd; i++) {
        arr.push({ text: i, value: i })
      }
      if (end - this.page_index >= showPageCount) {
        arr.push({
          text: '...',
          value: '',
          show: 2
        })
      }
      arr.push({ text: end, value: end, show: '' })
      arr.map((e, index) => {
        if (e.text === '...' && e.show === 2) {
          e.value = arr[index - 1].value + 1
        }
        if (e.text === '...' && e.show === 1) {
          e.value = arr[index + 1].value - 1
        }
        return e
      })
      return arr
    },
    hasPrev () {
      return (this.page_index === 1) ? 'page-item-disabled' : ''
    },
    hasPagination () {
      return this.pageNumber.length > 1
    },
    hasNext () {
      return this.page_index === this.totalPages ? 'page-item-disabled' : ''
    },
    showPage () {
      return this.totalPages > 1
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheet/user/list_user.scss';
  @import '@/assets/stylesheet/admin/vendor.scss';
  @import '@/assets/stylesheet/auth/dashboard.scss';
  @import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Employee/List.vue